// Vendor imports
const _ = require('lodash')
// Model imports
const {
  ARTICLE_LOADED,
  ARTICLE_MIXES_UPDATED
} = require('./actions')
const ArticleModelRecord = require('./record')

/* eslint-disable complexity */
function articleReducer(state, { type, payload }) {
  // Sanity check
  if (!payload || !(state instanceof ArticleModelRecord)) {
    return state
  }
  // Ignore actions that don't refer to this article
  if (state['url_id'] !== payload.urlId) {
    return state
  }
  switch (type) {
    case ARTICLE_LOADED:
      return state.mergeDeep(payload.article)
    case ARTICLE_MIXES_UPDATED:
      return state.merge({
        hasMix: !_.isEmpty(payload.mixIds)
      })
    default:
      return state
  }
}
/* eslint-enable complexity */

module.exports = articleReducer
